import {
  CLEAR_CHAT_HISTORY,
  CREATE_NEW_CHAT,
  GET_OLD_CHATS,
  UPADTE_CHAT_LABEL,
  SET_ACTIVE_CHAT,
  DELETE_CHAT_HISTORY,
  SET_SEARCH_QUERY,
} from 'store/types/chat.type'

export const getSuperCommand = async () => {
  const response = await fetch('/api/super-commands/get-command')
  let jsonResponse = await response.json()
  return jsonResponse
}

export const createNewChat =
  (userID, title = 'New Chat', chat_type = null, callback = null) =>
  async (dispatch) => {
    let data = {
      userID: userID,
      title: title,
      chat_type: chat_type,
    }
    const response = await fetch('/api/chat/save-chat', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json' },
    })
    const jsonResponse = await response.json()
    dispatch({
      type: CREATE_NEW_CHAT,
      payload: jsonResponse,
    })

    callback && callback(jsonResponse)
  }

export const getChats = (userID) => async (dispatch) => {
  const response = await fetch('/api/chat/get-chat?usp=' + userID)
  const jsonResponse = await response.json()
  dispatch({
    type: GET_OLD_CHATS,
    payload: jsonResponse,
  })
}

export const updateChatLabel = (chatID, title) => async (dispatch) => {
  let data = {
    chatID: chatID,
    title: title,
  }
  await fetch('/api/chat/update-chat', {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
  })
  dispatch({
    type: UPADTE_CHAT_LABEL,
    payload: { chatId: chatID.toString(), chatLabel: title },
  })
}

export const deleteChatsApi = (userID, chatID) => async (dispatch) => {
  let data = {
    userID: userID,
    chatID: chatID,
  }
  await fetch('/api/chat/delete-chat', {
    method: 'DELETE',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
  })
  if (chatID === 'all') {
    dispatch({
      type: CLEAR_CHAT_HISTORY,
    })
  }
}

const sendOpenai = async (messages) => {
  try {
    const response = await fetch('/api/chat/openai', {
      method: 'POST',
      body: JSON.stringify({ messages }),
      headers: { 'Content-Type': 'application/json' },
    })
    const jsonResponse = await response.json()
    if (jsonResponse.error) throw new Error(jsonResponse.error)
    return jsonResponse
  } catch (error) {
    throw new Error(error.message || 'Failed to get response from OpenAI')
  }
}

const sendClaude = async (data) => {
  try {
    const response = await fetch('/api/search/claude', {
      method: 'POST',
      body: JSON.stringify({
        data,
      }),
    })
    const jsonResponse = await response.json()
    if (jsonResponse.error) throw new Error(jsonResponse.error)

    if (jsonResponse?.content) {
      const content = jsonResponse.content
      return { role: 'assistant', content: content[content.length - 1].text }
    }
    throw new Error('Invalid response format from Claude')
  } catch (error) {
    throw new Error(error.message || 'Failed to get response from Claude')
  }
}

const sendGroq = async (data) => {
  try {
    const response = await fetch('/api/search/groq', {
      method: 'POST',
      body: JSON.stringify({
        data,
      }),
    })
    const jsonResponse = await response.json()
    if (jsonResponse.error) throw new Error(jsonResponse.error)

    const { choices } = jsonResponse
    if (choices && choices.length > 0) {
      return choices[choices.length - 1].message
    }
    throw new Error('Invalid response format from Groq')
  } catch (error) {
    throw new Error(error.message || 'Failed to get response from Groq')
  }
}

export const sendMessageTo3rdParty = async (messagesList, type) => {
  try {
    let botResponse
    switch (type) {
      case 'groq':
        botResponse = await sendGroq(messagesList)
        break
      case 'gpt4o':
        botResponse = await sendOpenai(messagesList)
        break
      case 'claude':
        botResponse = await sendClaude(messagesList)
        break
      case 'capitol':
        botResponse = await sendOpenai(messagesList)
        break
      default:
        throw new Error('Invalid AI model selected')
    }
    return { success: true, data: botResponse }
  } catch (error) {
    return { success: false, error: error.message }
  }
}

export const saveChatMessage = async (data) => {
  const response = await fetch('/api/msg/save-msg', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
  })
  let jsonResponse = await response.json()
  return jsonResponse
}

export const getChatMessages = async (data) => {
  const response = await fetch('/api/msg/get-msg', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
  })
  let jsonResponse = await response.json()
  return jsonResponse
}

export const updateChatMessages = async (data) => {
  const response = await fetch('/api/msg/update-msg', {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
  })
  let jsonResponse = await response.json()
  return jsonResponse
}

export const shareChat = async (chat_id) => {
  const response = await fetch('/api/chat/share-chat?chat_id=' + chat_id)
  let jsonResponse = await response.json()
  return jsonResponse
}

export const addSearchQuery = (payload) => async (dispatch) => {
  dispatch({
    type: SET_SEARCH_QUERY,
    payload: payload,
  })
}

export const setActiveChat = (id, type) => async (dispatch) => {
  dispatch({
    type: SET_ACTIVE_CHAT,
    payload: {
      id,
      type,
    },
  })
}

export const handleChatDelete = (chatId) => async (dispatch) => {
  dispatch({
    type: DELETE_CHAT_HISTORY,
    payload: { chatId },
  })
}
